import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import gsap from 'gsap';
import bowser from 'bowser';

gsap.registerPlugin(ScrollTrigger);

let scrollTriggerConfig = {
  ignoreMobileResize: true,
};

if (bowser.android) {
  scrollTriggerConfig = {
    ...scrollTriggerConfig,
    ...{
      syncInterval: 999999999, // weird input-focus issue on Android -> https://greensock.com/forums/topic/28737-android-resize-event-issue/
    },
  };
}

ScrollTrigger.config(scrollTriggerConfig);

export const defaultScrollTriggerOptions = {
  start: 'top bottom',
  end: 'bottom top',
  scrub: false,
};

export const getDefaultScrollTriggerVars = (
  options?: ScrollTrigger.StaticVars,
): ScrollTrigger.StaticVars => ({
  ...defaultScrollTriggerOptions,
  ...options,
});

export const createScrollTrigger = (
  trigger: HTMLElement,
  animation?: gsap.core.Timeline,
  vars?: ScrollTrigger.Vars,
): ScrollTrigger =>
  ScrollTrigger.create({
    animation,
    trigger,
    ...getDefaultScrollTriggerVars(vars),
  });
// ScrollTrigger.update();
// return scrollTrigger;
